import React from 'react';
import { Box, Typography, Tooltip, Fab } from '@mui/material';
import AnalyticsIcon from '@mui/icons-material/Analytics';   
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import styles from './DataQualityHeader.styles';

import ChipFilter from '../../../../components/filters/ChipFilter';
import DateRangePicker from '../../../../components/filters/DateRangePicker';

export default function DataQualityHeader({
  title = 'Data Quality Summary',
  filters,
  setFilters,
  state,          
  draftRange,    
  setDraftRange,
  applyDateRange, 
  onExport,
}) {
  return (
    <Box sx={styles.headerRow}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <AnalyticsIcon sx={{ ...styles.pageTitle, mr: 1 }} />
        <Typography sx={styles.pageTitle}>{title}</Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5 }}>
        <Tooltip title="Export to CSV" arrow>
          <Fab size="small" sx={styles.fabButton} onClick={onExport}>
            <FileDownloadIcon fontSize="small" />
          </Fab>
        </Tooltip>

        <ChipFilter
          type="operator"
          label="Operator"
          values={state.ops}
          selectedValues={filters.operator}
          onToggle={(_, v) => {
            const next = filters.operator.includes(v)
              ? filters.operator.filter((x) => x !== v)
              : [...filters.operator, v];
            setFilters((p) => ({ ...p, operator: next, unit: [], meter: [] }));
          }}
          onClear={() => setFilters((p) => ({ ...p, operator: [], unit: [], meter: [] }))}
          labelMap={state.labelMap}
        />

        <ChipFilter
          type="unit"
          label="Unit"
          values={state.visUnits}
          selectedValues={filters.unit}
          onToggle={(_, v) => {
            const next = filters.unit.includes(v)
              ? filters.unit.filter((x) => x !== v)
              : [...filters.unit, v];
            setFilters((p) => ({ ...p, unit: next, meter: [] }));
          }}
          onClear={() => setFilters((p) => ({ ...p, unit: [], meter: [] }))}
        />

        <ChipFilter
          type="meter"
          label="Meter"
          values={state.visMeters}
          selectedValues={filters.meter}
          onToggle={(_, v) => {
            const next = filters.meter.includes(v)
              ? filters.meter.filter((x) => x !== v)
              : [...filters.meter, v];
            setFilters((p) => ({ ...p, meter: next }));
          }}
          onClear={() => setFilters((p) => ({ ...p, meter: [] }))}
        />

        <DateRangePicker
          dateRange={draftRange}
          setDateRange={setDraftRange}
          onApply={(r) => applyDateRange(r ?? { start: '', end: '' })}
        />
      </Box>
    </Box>
  );
}
